module.exports = __webpack_public_path__ + "static/media/james_jiang_resume.5ec21799.pdf";